import styles from "./GridItemMiddleTextDiv.module.css";
const GridItemMiddleTextDiv = ({ type, data }) => {
  return type === "B" ? (
    <div className={`${styles.main_divB} ignoreDrag`}>
      <div className={styles.div_topB}>
        {data[0].split(" ").map((item) => {
          return <div>{item}</div>;
        })}
        {/* {data[0]} */}
      </div>
      <div className={styles.mid_hrB}></div>
      <div className={styles.div_bottomB}>
        <div className={styles.text_middleB}>{data[1]}</div>
        <div className={styles.text_bottomB}>{data[2]}</div>
      </div>
    </div>
  ) : type === "C" ? (
    <div className={`${styles.main_divB} ignoreDrag`}>
      <div className={styles.div_topB}>
        {data[0].split(" ").map((item) => {
          return <div>{item}</div>;
        })}
        {/* {data[0]} */}
      </div>
      <div className={styles.mid_hrB}></div>
      <div className={styles.div_bottomB}>
        <div className={styles.text_middleB}>{data[1]}</div>
      </div>
    </div>
  ) : (
    <div className={`${styles.main_divA} ignoreDrag`}>
      <div className={styles.div_topA}>
        <div className={styles.div_topA_top}>
          {/* {data[0].split(" ").map((item) => {
            return <div>{item}</div>;
          })} */}
          {data[0]}
        </div>
        <div className={styles.div_topA_bottom}>{data[1]}</div>
      </div>
      <div className={styles.mid_hrA}></div>
      <div className={styles.div_bottomA}>
        <div className={styles.text_middleA}>{data[2]}</div>
        <div className={styles.text_middleA}>{data[3]}</div>
        <div className={styles.text_middleA}>{data[4]}</div>
        <div className={styles.text_middleA}>{data[5]}</div>
      </div>
    </div>
  );
};
export default GridItemMiddleTextDiv;
